module.exports = __webpack_public_path__ + "static/img/gp4.bf7e1f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/groupbuild/gp4.png
// module id = FizZ
// module chunks = 18